import { createSelector } from "reselect";

import { State } from "common/types/redux";

import {
  getAllSections,
  makeGetCourseLeafSectionIds
} from "seneca-common/features/course/state";
import { getSectionStats } from "seneca-common/features/stats/state";

import { getAccurateNumberOfModuleIdsIncorrect } from "features/wrong-answers/selectors/getAccurateWrongAnswersModuleIds";

type GetTotalWrongAnswersInCourse = (state: State) => number;

export default function makeGetTotalWrongAnswersInCourse(
  courseId: string
): GetTotalWrongAnswersInCourse {
  const getCourseLeafSectionIds = makeGetCourseLeafSectionIds(courseId);
  return createSelector(
    getAllSections,
    getSectionStats,
    getCourseLeafSectionIds,
    (sections, sectionStats, leafSectionIds) =>
      leafSectionIds.reduce(
        (sum, sectionId) =>
          sum +
          getAccurateNumberOfModuleIdsIncorrect(
            sectionStats as any,
            sections,
            sectionId
          ),
        0
      )
  );
}
